import { render, staticRenderFns } from "./ModalCriarEditarItemFeriado.vue?vue&type=template&id=a8d4fd06&scoped=true"
import script from "./ModalCriarEditarItemFeriado.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarItemFeriado.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarItemFeriado.vue?vue&type=style&index=0&id=a8d4fd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d4fd06",
  null
  
)

export default component.exports